import { Card } from '../components/Card';
import { MetricRow } from '../components/MetricRow';
import { ScoreRing } from '../components/ScoreRing';
import { useHealthData } from '../services/HealthDataContext';
import { getMetricSeries } from '../services/metrics';

export function RecoveryScreen() {
  const { today, todayKey, scores, baselines, historyByDate } = useHealthData();

  const series = (metric: Parameters<typeof getMetricSeries>[1]) =>
    getMetricSeries(historyByDate, metric, todayKey, 14).map((point) => point.value);

  return (
    <div className="screen screen--recovery">
      <div className="screen__score-header">
        <ScoreRing score={scores.recoveryScore} label="Recuperacion" size={140} />
        <div className="screen__score-summary">
          <p className="screen__score-summary-title">HRV {today.recovery.hrv} ms</p>
          <p className="screen__score-summary-subtitle">FC en reposo {today.recovery.restingHeartRate} lpm</p>
        </div>
      </div>

      <Card title="Senales de recuperacion" subtitle="Comparadas con tu baseline personal">
        <div className="metric-grid">
          <MetricRow
            label="HRV"
            value={String(today.recovery.hrv)}
            unit="ms"
            baseline={baselines.metrics.hrv?.[30]}
            series={series('hrv')}
          />
          <MetricRow
            label="FC en reposo"
            value={String(today.recovery.restingHeartRate)}
            unit="lpm"
            baseline={baselines.metrics.restingHeartRate?.[30]}
            series={series('restingHeartRate')}
          />
          <MetricRow label="FC promedio" value={String(today.recovery.averageHeartRate)} unit="lpm" hideBaseline />
          <MetricRow label="FC minima" value={String(today.recovery.minHeartRate)} unit="lpm" hideBaseline />
          <MetricRow
            label="SpO2"
            value={String(today.recovery.spo2)}
            unit="%"
            baseline={baselines.metrics.spo2?.[30]}
            series={series('spo2')}
          />
          <MetricRow
            label="Frec. respiratoria"
            value={String(today.recovery.respiratoryRate)}
            unit="rpm"
            baseline={baselines.metrics.respiratoryRate?.[30]}
            series={series('respiratoryRate')}
          />
          <MetricRow
            label="Desv. de temperatura"
            value={today.recovery.temperatureDeviation > 0 ? `+${today.recovery.temperatureDeviation}` : String(today.recovery.temperatureDeviation)}
            unit="°C"
            hideBaseline
          />
        </div>
      </Card>
    </div>
  );
}
